import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  withCredentials: true,
});

// Auth
export const getMe      = ()      => api.get("/auth/me");
export const logout     = ()      => api.post("/auth/logout");

// Mitarbeiter
export const getEmployees     = (params) => api.get("/employees",       { params });
export const getEmployeeStats = ()       => api.get("/employees/stats");
export const getEmployee      = (hrlabId) => api.get(`/employees/${hrlabId}`);
export const setAdExclusion   = (hrlabId, payload) => api.patch(`/employees/${hrlabId}/ad-exclude`, payload);
export const setContactExclusion = (hrlabId, payload) => api.patch(`/employees/${hrlabId}/contact-exclude`, payload);
export const setContactDisplayName = (hrlabId, displayName) => api.patch(`/employees/${hrlabId}/contact-display-name`, { display_name: displayName });
export const setContactName = (hrlabId, payload) => api.patch(`/employees/${hrlabId}/contact-name`, payload);
export const updateEmployeeContact = (hrlabId, payload) => api.patch(`/employees/${hrlabId}/contact`, payload);
export const getEmployeeADDetail = (hrlabId) => api.get(`/employees/${hrlabId}/ad-detail`);

// Sync
export const importHRLab   = ()        => api.post("/sync/import-hrlab");
export const runSync       = (options) => api.post("/sync/run",   options);
export const getSyncDiff   = ()        => api.get("/sync/diff");
export const getSyncPreview = ()       => api.get("/sync/preview");
export const executeSync   = (payload) => api.post("/sync/execute", payload);
export const getADUsers    = ()        => api.get("/sync/ad-users");
export const linkEmployeeAd   = (hrlabId, adUserId) => api.post(`/sync/link/${hrlabId}`, { ad_user_id: adUserId });
export const unlinkEmployeeAd = (hrlabId)           => api.post(`/sync/unlink/${hrlabId}`);
export const getDebugMatch = ()        => api.get("/sync/debug-match");
export const getSyncLogs   = (limit = 20) => api.get("/sync/logs", { params: { limit } });
export const getSyncLog    = (id)      => api.get(`/sync/logs/${id}`);
export const getLicenseSkus = ()       => api.get("/sync/license-skus");

// WP Office Sync (Plugin-Fernsteuerung, siehe README_Adapter.md)
export const wpOfficeHealth    = ()        => api.get("/sync/wp-office/health");
export const runWpOfficeDelta  = ()        => api.post("/sync/wp-office/delta");
export const runWpOfficeBulk   = (resume = false) => api.post("/sync/wp-office/bulk", { resume });
export const getWpOfficeStatus = ()        => api.get("/sync/wp-office/status");

// Kontaktverteilung
export const getContactsPreview  = () => api.get("/sync/contacts-preview");
export const executeContactsSync = () => api.post("/sync/contacts-execute");

// Kontakte-Übersicht (Mitarbeiterliste + Drilldown)
export const getContactsOverview   = () => api.get("/sync/contacts-overview");
export const getOwnerContactsDetail = (hrlabId) => api.get(`/sync/contacts-overview/${hrlabId}`);

// Kontakte-Tab: Debug/Einzel-Aktionen
export const syncOwnerContacts  = (hrlabId)               => api.post(`/sync/contacts-overview/${hrlabId}/sync`);
export const updateSingleContact = (hrlabId, contactHrlabId) => api.post(`/sync/contacts-overview/${hrlabId}/contacts/${contactHrlabId}/update`);

// Doppelte Kontakte im Mitarbeiterverzeichnis
export const getDuplicateContactsPreview     = () => api.get("/sync/duplicate-contacts-preview");
export const executeDuplicateContactsCleanup = () => api.post("/sync/duplicate-contacts-cleanup");

// Manuelle Kontakte (externe Personen/Stellen ohne Mitarbeiter-Datensatz)
export const getManualContacts   = ()           => api.get("/sync/manual-contacts");
export const createManualContact = (payload)    => api.post("/sync/manual-contacts", payload);
export const updateManualContact = (id, payload) => api.put(`/sync/manual-contacts/${id}`, payload);
export const deleteManualContact = (id)         => api.delete(`/sync/manual-contacts/${id}`);

// Service-Accounts (Outlook-Konten außerhalb HRLab, die das Mitarbeiterverzeichnis empfangen)
export const getServiceAccounts         = ()              => api.get("/sync/service-accounts");
export const createServiceAccount       = (payload)       => api.post("/sync/service-accounts", payload);
export const updateServiceAccount       = (id, payload)   => api.put(`/sync/service-accounts/${id}`, payload);
export const deleteServiceAccount       = (id)            => api.delete(`/sync/service-accounts/${id}`);
export const resolveServiceAccountAdId  = (id)            => api.post(`/sync/service-accounts/${id}/resolve`);

// AD-Profil-Synchronisation (Standort-Vorlagen -> Azure-AD-Profile)
export const getAdProfileSyncPreview = () => api.get("/sync/ad-profile-sync-preview");
export const runAdProfileSync        = () => api.post("/sync/ad-profile-sync");

// Alte Organisations-Kontakte (createOrgContact-Rollout)
export const getOrgContacts   = () => api.get("/sync/org-contacts");
export const deleteOrgContact = (id) => api.post(`/sync/org-contacts/${id}/delete`);

// Offboarding
export const getOffboardingQueue  = ()          => api.get("/sync/offboarding");
export const deactivateEmployee   = (hrlabId)   => api.post(`/sync/offboard/${hrlabId}/deactivate`);
export const deleteEmployee       = (hrlabId)   => api.post(`/sync/offboard/${hrlabId}/delete`);

// Config
export const getConfig    = ()     => api.get("/config");
export const updateConfig = (data) => api.patch("/config", data);

// Standorte
export const getDepartments = () => api.get("/employees/meta/departments");
export const getLocations = () => api.get("/config/locations");
export const createLocation = (payload) => api.post("/config/locations", payload);
export const updateLocation = (id, payload) => api.put(`/config/locations/${id}`, payload);
export const deleteLocation = (id) => api.delete(`/config/locations/${id}`);
export const setDepartmentLocation = (department, locationId) =>
  api.put(`/config/department-locations/${encodeURIComponent(department)}`, { location_id: locationId });

// Drucker-Adressbuch (Canon iR-ADV C3826i)
export const getDruckerData       = ()           => api.get("/drucker/data");
export const toggleDruckerExclude = (email)      => api.post("/drucker/exclude", { email });
export const addDruckerContact    = (name, email) => api.post("/drucker/contacts", { name, email });
export const deleteDruckerContact = (id)         => api.delete(`/drucker/contacts/${id}`);
export const syncDrucker          = (maxOps)     => api.post("/drucker/sync", maxOps ? { maxOps } : {});
export const testDruckerConn      = ()           => api.post("/drucker/test");
export const probeDrucker         = ()           => api.post("/drucker/probe");

export default api;
